import { SideBarContent, SideBarContentProps } from './Content';
import { sidebarClasses } from './styles';

type SideBarProps = SideBarContentProps;

export function SideBar(props: SideBarProps) {
  return (
    <aside
      id="dashboard-sidebar"
      data-testid="dashboard-sidebar"
      className={sidebarClasses.container}
    >
      <SideBarContent {...props} />
    </aside>
  );
}
